import { SettingState } from 'src/types/redux';
import {
  FETCH_SETTING_FAILURE,
  FETCH_SETTING_REQUEST,
  FETCH_SETTING_SUCCESS,
  SettingActionType,
} from '../types/settingType';

const initialState: SettingState = {
  error: '',
  loading: false,
  settingData: [],
};

export const settingReducer = (
  state = initialState,
  action: SettingActionType
): SettingState => {
  switch (action?.type) {
    case FETCH_SETTING_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        settingData: action?.payload,
      };
    case FETCH_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
